import { useStore } from "vuex"

export default {
    name: "GalleryCard",
    props: {
        result: {
            type: Object,
            required: true,
            default: {}
        }
    },
    setup() {
        const store = useStore()

        return {
            getLabel: (labelKey) =>
                store.getters["labels/getLabel"]({
                    labelCollection: "GalleryCard",
                    labelKey,
                }),
        }
    }
}